module.exports = __webpack_public_path__ + "img/reindeer-2.354590f3.png";